export default __webpack_public_path__ + "static/media/header-video.3e7857c8.jpg";